
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 5.25V4.21H9.79v1.04H.164zm0 3.242V7.453H9.79v1.04H.164zm.094-6.219A4.482 4.482 0 011.312.743 2.193 2.193 0 012.867.124c.625 0 1.37.273 2.235.82.864.547 1.52.82 1.968.82.443 0 .813-.117 1.11-.35.297-.235.596-.6.898-1.095l.625.422c-.224.464-.578.932-1.062 1.406-.485.47-1.073.704-1.766.704-.667 0-1.43-.274-2.29-.82-.853-.548-1.507-.821-1.96-.821-.38 0-.714.12-1 .36-.286.239-.54.588-.758 1.046l-.61-.344z","fill":"currentColor"}})])
          )
        }
      }
    